import React from 'react';
import { PaymentsProcessor } from '@weave/schema-gen-ts/dist/schemas/payments-platform/payments-config/payments_config.pb';
import { useMerchant } from '../use-merchant.hook';
import {
  ActiveMerchantInfo,
  ActiveMerchantInfoProps,
} from './active-merchant-info.component';

export const ActiveMerchantInfoStripe = ({
  SunbitStatus,
  showTitle = false,
}: Pick<ActiveMerchantInfoProps, 'SunbitStatus'> & { showTitle?: boolean }) => {
  const { chargesEnabled, payoutsEnabled, activeProcessor } = useMerchant();

  return (
    <ActiveMerchantInfo
      title={showTitle ? 'Stripe Merchant Account' : undefined}
      processorType={PaymentsProcessor.PAYMENTS_PROCESSOR_STRIPE}
      SunbitStatus={SunbitStatus}
      accountId={activeProcessor?.stripeId}
      accountType={activeProcessor?.stripeAccountType}
      statusList={[
        { feature: 'Payments', enabled: chargesEnabled },
        { feature: 'Payouts', enabled: payoutsEnabled },
      ]}
    />
  );
};
